import React from 'react';
import { useSearchParams } from 'next/navigation';
import useCreateQueryString from '@/hooks/useCreateQueryString';
import useFetch from './useFetch';
import { Images } from '@/components';

const CategoryTool: React.FC = () => {
  const searchParam = useSearchParams();
  const createQueryString = useCreateQueryString();
  const category = searchParam.get('categoryId') ?? '';
  const onChangeCategory = (key: string) => {
    if (category === key) createQueryString('categoryId', '', { scroll: false });
    else createQueryString('categoryId', key, { scroll: false });
  };
  const { list } = useFetch();
  return (
    <div className="mt-6 overflow-x-auto scrollbar-hide">
        <div className="flex gap-4">
          {list.map(cate => (
            <div 
              aria-expanded={category === cate.id.toString()}
              aria-checked={Boolean(category)}
              key={cate.id}
              onClick={() => onChangeCategory(cate.id.toString())}
              style={{ color: cate.color }}
              className="flex flex-1 aria-checked:opacity-50 aria-expanded:opacity-100 cursor-pointer items-center gap-3 px-3 py-[10px] sm:py-[6px] rounded-lg bg-[#F8F9FD] border-1 border-[#F0F2FA] min-w-[212px] sm:min-w-[200px]"
            >
              <div className="sm:scale-80">
                <Images alt="icon" src={cate.icon} />
              </div>
              <div className="text-[14px] sm:text-[13px] font-semibold whitespace-nowrap">
                {cate.title}
              </div>
            </div>
          ))}
        </div>
      </div>
  );
}

export default CategoryTool;